import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { OnBehalfIndicator } from 'services/professional/certificates/certificates.interface';
import { Placement } from '@ng-bootstrap/ng-bootstrap';
import { ON_BEHALF_ACTION_NAMES, ON_BEHALF_ROLE_LABEL } from 'constants/certification.constants';
import { ROLE_NAMES } from 'constants/role.constants';
import { ComputedFrom } from '@certemy/common';

@Component({
  selector: 'cm-on-behalf-indicator',
  templateUrl: 'on-behalf-indicator.component.html',
  styleUrls: ['on-behalf-indicator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OnBehalfIndicatorComponent {
  @Input() onBehalfIndicator: OnBehalfIndicator;
  @Input() tooltipPlacement: Placement = 'left';

  @ComputedFrom('onBehalfIndicator')
  get roleId(): number {
    return this.onBehalfIndicator.profile.role_id;
  }

  @ComputedFrom('onBehalfIndicator')
  get onBehalfTooltip(): string {
    const { first_name, last_name } = this.onBehalfIndicator.profile;
    const role = ROLE_NAMES[this.roleId];
    const action = ON_BEHALF_ACTION_NAMES[this.onBehalfIndicator.action];

    return `${action} by ${role} ${first_name} ${last_name}`;
  }

  @ComputedFrom('onBehalfIndicator')
  get indicatorRoleLabel(): string {
    return ON_BEHALF_ROLE_LABEL[this.roleId];
  }
}
